import { VueRegistration } from '@abaco/web-common/src/app';

const globals: VueRegistration = {
    // CONTAINERS
    "PedologyContainer": () => import("./components/PedologyContainer.vue"),
    "PedologySingleTileContainerResponsive": () => import("./components/PedologySingleTileContainerResponsive.vue"),

    // HOME VIEW
    "PedoAllPlots": () => import("./components/tiles/pedology/PedoAllPlots.vue"),

    //TILES
    "PedoAllPlotsInMapTile": () => import("./components/tiles/pedology/PedoAllPlotsInMapTile.vue"),
    "PedoNewDataFormTile": () => import("./components/tiles/PedoNewDataFormTile.vue"),

    //Popup
    "AbcPopup": () => import("./components/webcomponent/AbcPopup.vue")
};


export default globals;
